module.exports = __webpack_public_path__ + "img/logo-cic.8dba6e81.png";